import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { CommonProps, ExportReportPanel } from './ExportReportPanel';
import {
  IncludeCorrectAnswers,
  IncludeExplanations,
  ReportOptionType,
} from './ReportOption';

const ExportReportsIndividual = (props: CommonProps) => {
  const reportOptions: ReportOptionType[] = [
    IncludeExplanations,
    IncludeCorrectAnswers,
  ];

  return (
    <ExportReportPanel
      {...props}
      shouldShowProBadgeInHeader={false}
      shouldShowProBadge={true}
      shouldShowPaywallOnReportsButtonClicked={false}
      title={translate('Individual Student PDFs')}
      description={translate(
        'Export a personalized results PDF for each student who took part in the activity.'
      )}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.IndividualStudentPDF}
    />
  );
};

export { ExportReportsIndividual };
export default ExportReportsIndividual;
